import { Image } from "antd";
import { FC, useState } from "react";

//!COMPONENTS
import Card from "components/card";

//!IMAGES
import Plus from "../../../assets/images/teacher/iconePlus.svg";

//!STYLES
import s from "./assets/card.module.css";

type Props = {
  onClick?: any;
};

const CardAddCours: FC<Props> = ({ onClick }) => {

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [isXsScreen, setIsXsScreen] = useState(window.innerWidth > 767 && window.innerWidth <= 1151);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth > 1151 && window.innerWidth <= 1321);
  const [isMediumScreen, setIsMediumScreen] = useState(window.innerWidth > 1321 && window.innerWidth <= 1606);
  const [isNormalScreen, setIsNormalScreen] = useState(window.innerWidth > 1606 && window.innerWidth <= 1799);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
    setIsXsScreen(window.innerWidth > 767 && window.innerWidth <= 1151);
    setIsSmallScreen(window.innerWidth > 1151 && window.innerWidth <= 1321);
    setIsMediumScreen(window.innerWidth > 1321 && window.innerWidth <= 1606);
    setIsNormalScreen(window.innerWidth > 1606 && window.innerWidth <= 1799);
  };
  window.addEventListener('resize', handleResize);

  return (
    <Card className={s.card}>
      <Image
        preview={false}
        width={isMobile ? 20 : 50}
        src={Plus}
        alt="logo"
        onClick={onClick}
      />
      <span>Ajouter une classe</span>
    </Card>
  );
};

export default CardAddCours;
